import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ArtikelVerkoopPrijzen } from '../dto/artikel-verkoop-prijzen';
import { CrudService } from '@mango/core';

@Injectable({ providedIn: 'root' })
export class ArtikelVerkoopPrijzenService extends CrudService<ArtikelVerkoopPrijzen> {

    constructor(injector: Injector) { super(ArtikelVerkoopPrijzen, injector); }

}
